import React from "react";

/**
 * Erudition Score logo — uses the official product icon from /erudition-logo.png.
 * Renders a royal-blue square tile with the geometric mark inside.
 *
 * Props:
 *  - size: pixel size of the square tile (default 28)
 *  - variant: "tile" (royal blue square, default) | "mark" (transparent, useful on dark bg)
 *  - className: extra classes
 */
const ASSET = "/erudition-logo.png";

export const Logo = ({ size = 28, variant = "tile", className = "" }) => {
  const style = { width: size, height: size };
  if (variant === "mark") {
    return (
      <img
        src={ASSET}
        alt="Erudition Score"
        style={style}
        className={`block object-contain ${className}`}
        data-testid="logo-mark-img"
      />
    );
  }
  return (
    <span
      style={style}
      className={`inline-flex items-center justify-center bg-[#4267B4] overflow-hidden ${className}`}
      data-testid="logo-tile"
    >
      <img
        src={ASSET}
        alt="Erudition Score"
        style={{ width: "100%", height: "100%" }}
        className="block object-contain"
      />
    </span>
  );
};

export const LogoMark = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="logo-wordmark">
    <Logo size={32} />
    <span className="font-display text-[22px] tracking-tight text-[var(--es-ink)]">
      Erudition <span className="italic text-[var(--es-blue)]">Score</span>
    </span>
  </div>
);

export default Logo;
